const NotFound = () => "NotFound";
export default NotFound;